export default __webpack_public_path__ + "media/images/main/plus-2843a9a39b99fb8261b159bae280ad47.png";